import React, { useState, useEffect, useMemo } from 'react';
import api from '../services/api';
import Loading from './Loading';
import { FaUser, FaSearch } from 'react-icons/fa';
import './MudarClienteModal.css';

const MudarClienteModal = ({ imovelId, onClose, onClienteChanged }) => {
    const [allClientes, setAllClientes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchClientes = async () => {
            setLoading(true);
            try {
                const response = await api.get('/clientes?pageSize=1000'); // Fetch a large list
                setAllClientes(response.data.data);
            } catch (error) {
                setError('Erro ao carregar a lista de clientes.');
            } finally {
                setLoading(false);
            }
        };
        fetchClientes();
    }, []);

    const filteredClientes = useMemo(() => {
        if (!searchTerm) {
            return allClientes;
        }
        return allClientes.filter(c =>
            c.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
            c.documento?.includes(searchTerm)
        );
    }, [searchTerm, allClientes]);

    const handleSubmit = async () => {
        if (!selectedCliente) {
            setError('Nenhum cliente selecionado.');
            return;
        }
        setSaving(true);
        setError('');
        try {
            await api.post(`/imoveis/${imovelId}/mudar-proprietario`, { novo_cliente_id: selectedCliente.id });
            onClienteChanged();
            onClose();
        } catch (error) {
            setError('Erro ao salvar a alteração. Tente novamente.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-container" onClick={e => e.stopPropagation()}>
                <header className="modal-header">
                    <h2>Associar Proprietário</h2>
                    <p>Selecione um cliente da lista ou use a busca.</p>
                </header>

                <div className="modal-body">
                    <div className="search-bar">
                        <FaSearch className="search-icon" />
                        <input
                            type="text"
                            placeholder="Buscar por nome ou documento..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                        />
                    </div>

                    {error && <p className="error-message">{error}</p>}

                    <div className="client-list-container">
                        {loading ? (
                            <Loading />
                        ) : filteredClientes.length > 0 ? (
                            <ul className="client-list">
                                {filteredClientes.map(cliente => (
                                    <li
                                        key={cliente.id}
                                        className={`client-list-item ${selectedCliente?.id === cliente.id ? 'selected' : ''}`}
                                        onClick={() => setSelectedCliente(cliente)}
                                    >
                                        <FaUser className="client-icon" />
                                        <div className="client-info">
                                            <span className="client-name">{cliente.nome}</span>
                                            <span className="client-doc">{cliente.documento}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="no-results">Nenhum cliente encontrado.</p>
                        )}
                    </div>
                </div>

                <footer className="modal-footer">
                    <button type="button" className="button-secondary" onClick={onClose} disabled={saving}>
                        Cancelar
                    </button>
                    <button type="button" className="button-primary" onClick={handleSubmit} disabled={!selectedCliente || saving}>
                        {saving ? 'Salvando...' : 'Confirmar Associação'}
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default MudarClienteModal;